// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.burritowallet",
    name: "Burrito",
    homepage: "https://burritowallet.com",
    image_id: "7eec7187-3f48-4fda-53bb-b0ad55749a00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/app/burrito-wallet/id6449563083",
        android: "https://play.google.com/store/apps/details?id=com.burritowallet.app",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "burrito://",
        universal: "https://app.burritowallet.com",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map